import { getLocalizationById } from '@context/useMyRouting/helpers';
import getLocalizationByArgs from '@helpers/getLocalizationByArgs';
import { ServiceFieldType } from '@onlog-public/additional-services-types';
import { optionsGeneratorProcessor } from '@pages/AdditionalServices/containers/services/propertyOptionsGenerator/types';
import { EcoFeePackagesLoaderResponse } from '@services/requests/searchLoaders/ecoFeeLoader/EcoFeePackagesLoaderQuery';
import i18next from 'i18next';

import { SelectOption } from '../optionsGenerator/types';
import { OptionsCache } from '../optionsLoader/types';

/**
 * EcoFeePackageProcessor реализует процессор генерации опций для
 * свойств услуг типа "Упаковка экосбора"
 */
export class EcoFeePackageProcessor implements optionsGeneratorProcessor {
  /**
   * getType возвращает тип справочника, для которого реализован генератор
   */
  getType(): ServiceFieldType {
    return 'package';
  }

  /**
   * getOptions генерирует опции для вывода по переданным идентификаторам
   * и кэшу.
   * @param langID
   * @param items
   * @param _
   * @param cache
   */
  getOptions(langID: string, items: string[], _: string, cache: OptionsCache<any>): SelectOption[] {
    const langCode = getLocalizationById(langID).countryCode;
    const t = i18next.getFixedT(langCode);

    const packagesData: EcoFeePackagesLoaderResponse['items'] = items
      .map((i) => cache.cache[i])
      .filter((v) => !!v);

    return packagesData.map((d) => ({
      value: parseInt(d.id),
      label: `${t('Common:Package')}: ${getLocalizationByArgs(
        langID,
        d.default_name ?? '',
        d.localized_names_data
      )}`,
      description: `${t('Common:Group')} №${d.group.number_group} "${d.group.name ?? ''}" ${`/ ${t(
        'Common:RateValue'
      )}: ${d.group.rate_value ?? ''}  /  ${t('Common:Normative')}: ${
        d.group.normative_value ?? ''
      }  /  ${t('Common:Coefficient')}: ${d.group.coefficient ?? ''}`}`,
      origin: d,
    }));
  }
}
